import React from "react";
import ContentLoader from "react-content-loader";

const CardLoader = (props) => (
  <ContentLoader viewBox="0 0 400 400" speed={0.5} {...props}>
    <rect x="0" y="0" rx="5" ry="5" width="400" height="200" />
  </ContentLoader>
);

CardLoader.metadata = {
  name: "RoyalBhati",
  github: "royalbhati",
  description: "Dev.to card",
  filename: "DevtoCard",
};

export default CardLoader;
